import { sendBackendPagination } from "../../common/utils/pagination";
import { IProfitLossDto } from "../../interfaces/dashboard/IProfitLossDto";
import { IProfitLossFiltersDto } from "../../interfaces/dashboard/IProfitLossFiltersDto";
import { IProfitLossResumedDto } from "../../interfaces/dashboard/IProfitLossResumedDto";
import { IListPagination } from "../../interfaces/pagination/IListPagination";
import { IPagination } from "../../interfaces/pagination/IPagination";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetProfitLossResumedDashboard(isActive?: boolean | null) {
    if (isActive != null) {
        return await cryptoPortfolioService.get<IProfitLossResumedDto[]>(`/dashboard/profitlossresumed?isActive=${isActive}`);
    }

    return await cryptoPortfolioService.get<IProfitLossResumedDto[]>('/dashboard/profitlossresumed');
}

export async function tryGetProfitLossPaginatedDashboard(pagination: IPagination, profitLossFilters: IProfitLossFiltersDto) {
    return await cryptoPortfolioService.post<IListPagination<IProfitLossDto>>(
        `/dashboard/profitlosspaginated?page=${sendBackendPagination(pagination.page)}&pageSize=${pagination.rowsPerPage}`,
        profitLossFilters
    );
}